
export interface NextBackup {
    timeSpan: string;
    dateTime: Date;
    isFull: boolean;
    originalBackupTime: Date;
}
